import React, { ReactElement } from "react";
import { Table } from "antd";
import { rowClassName } from "../../DateRangeComparison";
import { ProcessedAdsByPartnerRecord } from "../../../redux/types/reportTypes";
import "./index.scss";

export const columns = [
  {
    title: "Cluster",
    dataIndex: "cluster",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Period 1",
    dataIndex: "period1",
  },
  {
    title: "Period 2",
    dataIndex: "period2",
  },
  {
    title: "Difference",
    dataIndex: "difference",
  },
  {
    title: "Percentual Difference",
    dataIndex: "percentualDifference",
  },
];

type PartnerTableProps = {
  loading: boolean;
  records: Array<ProcessedAdsByPartnerRecord>;
};

const PartnerTable = ({ loading, records }: PartnerTableProps): ReactElement => (
  <Table
    className="partner-table"
    dataSource={records}
    columns={columns}
    loading={loading}
    rowKey="name"
    pagination={false}
    scroll={{ y: 250 }}
    rowClassName={rowClassName}
  />
);

export default PartnerTable;
